import clsx from 'clsx';

export interface OptionSelect {
  value: string;
  label: string;
}

export interface BaseSelectProps {
  name: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;
  disabled?: boolean;
  options: OptionSelect[];
  [key: string]: any;
  classNameWrapper?: string;
}

export default function BaseSelect({
  name,
  label,
  value,
  onChange,
  errorMessage = '',
  disabled = false,
  options,
  classNameWrapper,
  ...props
}: BaseSelectProps) {
  return (
    <div className={clsx("form-icon relative", classNameWrapper )}>
      {label && (
        <label className="form-label font-medium dark:text-white mb-4" htmlFor={name}>
          {label} : <span className="text-red-600">*</span>
        </label>
      )}

      <div
        className={clsx('inline-block relative w-full', {
          'opacity-40': disabled,
        })}
      >
        <select
          id={name}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={clsx(
            'block appearance-none w-full bg-white border  px-4 py-2 pr-8 rounded shadow-smleading-tight focus:outline-none focus:shadow-outline',
            {
              'border-red-500': errorMessage !== '',
              'border-gray-200': errorMessage === '',
              'focus:border-indigo-600 dark:border-gray-500 dark:focus:border-indigo-600': true,
            },
            disabled
              ? 'bg-gray-100 dark:bg-gray-700 dark:text-white dark:opacity-60'
              : 'bg-transparent dark:text-gray-800',
            label ? 'mt-2' : ''
          )}
          disabled={disabled}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg
            className="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>
      </div>

      {errorMessage && <p className="text-red-500 text-xs mt-1">{errorMessage}</p>}
    </div>
  );
}
